import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FrontierMark from "@/components/FrontierMark";

export default function Login() {
    const startLogin = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/admin";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="min-h-screen" data-testid="login-page">
            <Header showCoords={false} />
            <section className="max-w-2xl mx-auto px-6 md:px-10 pt-24 pb-24">
                <div className="panel p-10 md:p-16 text-center">
                    <div className="flex justify-center mb-8">
                        <FrontierMark size="lg" />
                    </div>
                    <div className="overline-cobalt mb-5">§ Operator Access</div>
                    <h1
                        className="font-display"
                        style={{ fontSize: "clamp(36px, 5vw, 64px)", lineHeight: 0.98, color: "var(--ink)" }}
                    >
                        Restricted.
                    </h1>
                    <p
                        className="mt-6 max-w-md mx-auto"
                        style={{ color: "var(--ink-2)", fontSize: 15, lineHeight: 1.65 }}
                    >
                        This console is for the Frontier operator. Sign in with your
                        Google account to manage dispatches, events, videos, and
                        bookings.
                    </p>
                    <button onClick={startLogin} className="btn-primary mt-10" data-testid="google-login-btn">
                        Continue with Google
                    </button>
                </div>
            </section>
            <Footer />
        </div>
    );
}
